/* CupCus — phần chọn bức 2 của Christmas Pair trên trang sản phẩm.
   Mỗi lúc chỉ một nút mua: mở phần chọn thì ẩn nút Add to cart, thanh dính đáy (cc-pdp.js) đổi thành mua cả cặp
   và chỉ hiện khi nút Add both cuộn khỏi màn hình. Mã giảm do cc-offer-cart.js tự gắn khi giỏ đủ 2 tranh. */
(function () {
  var box = document.querySelector('[data-cc-pair]');
  if (!box) return;
  var root = box.parentNode;
  var I = JSON.parse(root.querySelector('[data-cc-pair-i18n]').textContent);
  // filter t mã hoá sẵn ký tự (' → &#39;); câu nào gắn bằng textContent phải giải mã trước
  var dec = document.createElement('textarea');
  Object.keys(I).forEach(function (k) { dec.innerHTML = I[k]; I[k] = dec.value; });
  var pick = box.querySelector('[data-cc-pair-pick]');
  var sheet = root.querySelector('[data-cc-pair-sheet]');
  var scrim = root.querySelector('[data-cc-pair-scrim]');
  var addBtn = box.querySelector('[data-cc-pair-add]');
  var moreBtn = box.querySelector('[data-cc-pair-more]');
  document.body.appendChild(sheet); document.body.appendChild(scrim);   // thoát khỏi khung cột sản phẩm

  var boxTimer, cartLine = null, touched = false, premOn = false, premWas = null, picked = [];
  var items = null, cur = 0, sizeId = null, loading = null, showAll = false, opener = null;
  var SHOW = 6;

  function P(k) { return box.querySelector('[data-p="' + k + '"]'); }
  function S(k) { return sheet.querySelector('[data-s="' + k + '"]'); }
  function page() { return window.ccPrice ? window.ccPrice() : null; }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fill(s, c) { return s.replace('[amount]', money(c)); }
  function pageImg() {             // ảnh đang hiện trên trang, đúng khung và hướng khách đã chọn
    var el = document.querySelector('.product-gallery img, .product__media img, [data-cc-group] img');
    return (el && (el.currentSrc || el.src)) || items[0].c;
  }
  function mainV() {                // đúng variant khách đang chọn trên trang
    var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = cartLine ? cartLine.id : (sel ? parseInt(sel.value, 10) : 0), hit = null;
    items[0].v.forEach(function (x) { if (x.id === id) hit = x; });
    return hit;
  }
  function pageSize() { var v = mainV(); return cartLine && !v ? cartLine.s : (v ? v.s : ''); }
  function chosen() {
    var hit = null;
    items[cur].v.forEach(function (v) { if (same(v.o, picked)) hit = v; });
    return hit;
  }
  function same(a, b) { return a.join('|') === b.join('|'); }
  function dims(t) { return (String(t).match(/\d+/g) || []).slice(0, 2).map(Number).sort(function (a, b) { return a - b; }).join('x'); }
  function values(i, k) {           // giá trị của một option, size xếp theo giá như trên trang
    var it = items[i], out = [], low = {};
    it.v.forEach(function (v) {
      var x = v.o[k];
      if (out.indexOf(x) < 0) out.push(x);
      if (!(x in low) || v.p < low[x]) low[x] = v.p;
    });
    return k === it.z ? out.sort(function (a, b) { return low[a] - low[b]; }) : out;
  }
  function settle(lock) {           // bộ chọn không có hàng thì lấy variant còn hàng gần nhất, giữ option khách vừa bấm
    var best = null, score = -1;
    items[cur].v.forEach(function (v) {
      if (!v.a || (lock !== undefined && v.o[lock] !== picked[lock])) return;
      var n = v.o.filter(function (x, k) { return x === picked[k]; }).length;
      if (n > score) { score = n; best = v; }
    });
    if (best) picked = best.o.slice();
  }
  function follow(ref) {            // tranh khác lấy cùng size và cùng lựa chọn nếu tranh đó có, còn lại lấy giá trị đầu
    var it = items[cur], want = dims(ref.s), low = ref.o.map(function (x) { return String(x).toLowerCase(); });
    picked = it.n.map(function (n, k) {
      var hit = values(cur, k).filter(function (x) { return k === it.z ? dims(x) === want : low.indexOf(String(x).toLowerCase()) > -1; })[0];
      return hit === undefined ? values(cur, k)[0] : hit;
    });
    settle();
  }
  function defaults() {             // mặc định: giống y bức 1; khách tự chọn thì giữ
    var m = mainV(), ref = m || (cartLine ? { o: [], s: cartLine.s } : null);
    if (!cur && m) { picked = m.o.slice(); return; }
    if (ref) follow(ref); else { picked = items[cur].v[0].o.slice(); settle(); }
  }
  function premFor() { var v = chosen(); return v && window.ccAddonFor ? window.ccAddonFor(v.s) : null; }
  function mainPrem() { return document.querySelector('[data-cc-addon-check]'); }
  function setMainPrem(on) {        // ô gốc lo Premium bức 1 khi bấm mua; đổi ô gốc để giá và giỏ theo đúng một đường
    var c = mainPrem();
    if (!c || c.checked === on) return;
    c.checked = on; c.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function buildPrem() {            // ô trong box chép từ ô gốc để luôn giống y hệt
    var row = P('premrow'), src = document.querySelector('[data-cc-addon]');
    if (row.firstChild || !src) return;
    var c = src.cloneNode(true);
    ['data-cc-addon', 'data-large', 'data-small-id', 'data-small-price', 'data-large-id', 'data-large-price', 'data-material'].forEach(function (a) { c.removeAttribute(a); });
    c.classList.remove('is-checked');
    var inp = c.querySelector('[data-cc-addon-check]'), pr = c.querySelector('[data-cc-addon-price]');
    inp.removeAttribute('data-cc-addon-check'); inp.setAttribute('data-cc-pair-prem', ''); inp.checked = false;
    pr.removeAttribute('data-cc-addon-price'); pr.setAttribute('data-p', 'premprice');
    row.appendChild(c);
  }

  function maths() {
    var pg = page(), v = chosen();
    if (!pg || !v) return null;
    var a = cartLine ? cartLine.price : Math.round(pg.value * 100), b = v.p;
    var extra = cartLine ? 0 : Math.round((pg.addon || 0) * 100);
    var pm = premOn ? premFor() : null;
    if (pm) extra += pm.price;
    var firstHigher = a >= b, hi = firstHigher ? a : b, lo = firstHigher ? b : a, d = Math.floor(lo / 2);
    return { a: a, b: b, extra: extra, firstHigher: firstHigher, hi: hi, lo: lo, d: d, total: hi + lo - d + extra };
  }
  function publish(open, busy) {
    var x = open ? maths() : null;
    window.ccPair = {
      open: !!(open && x), busy: !!busy, btn: addBtn, add: addBoth, label: cartLine ? I.barOne : I.barAdd,
      total: x ? money(x.total) : '', sub: x ? fill(I.bar, x.d) : ''
    };
    window.dispatchEvent(new Event('cc:pair'));
  }

  function drawTiles() {
    var t = P('tiles'), list = items.slice(0, showAll ? items.length : SHOW);
    // dãy tranh đã vẽ thì chỉ đổi ô đang chọn, không dựng lại: dựng lại giữa lúc khách chạm làm mất lần chạm trên điện thoại
    if (t.children.length === list.length) {
      Array.prototype.forEach.call(t.children, function (b, i) { b.setAttribute('aria-pressed', i === cur); });
      moreBtn.hidden = showAll || items.length <= SHOW;
      return;
    }
    t.textContent = '';
    list.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cc-pair__tile'; b.setAttribute('aria-pressed', i === cur);
      var im = document.createElement('img'); im.src = it.c; im.alt = ''; im.loading = 'lazy'; im.width = 130; im.height = 130;
      b.appendChild(im); var tl = document.createElement('span'); tl.className = 'cc-pair__tlabel'; tl.textContent = i ? it.t : I.same; b.appendChild(tl);
      b.onclick = function () { var v = chosen(); cur = i; if (touched && v) follow(v); draw(); };
      t.appendChild(b);
    });
    moreBtn.hidden = showAll || items.length <= SHOW;
  }
  function nice(t) { t = String(t); return t === t.toUpperCase() ? t.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); }) : t; }
  function drawOpts() {             // đủ option của tranh đang chọn, như khi xem chính tranh đó
    var t = P('opts'), it = items[cur]; t.textContent = '';
    it.n.forEach(function (name, k) {
      var vals = values(cur, k), isSize = k === it.z;
      if (vals.length < 2 && !isSize) return;
      var sl = document.createElement('div'), lab = document.createElement('span'), box2 = document.createElement('div');
      var show = function (x) { return isSize ? String(x).replace(/\s*x\s*/i, 'x') : nice(x); };
      sl.className = 'cc-pair__sl'; sl.appendChild(document.createTextNode(nice(name.replace(/^\w/, function (c) { return c.toUpperCase(); })) + ': '));
      lab.textContent = show(picked[k]); sl.appendChild(lab);
      box2.className = 'cc-pair__sizes' + (isSize ? '' : ' is-wide');
      vals.forEach(function (x) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = show(x); b.setAttribute('aria-pressed', x === picked[k]);
        b.disabled = !it.v.some(function (v) { return v.a && v.o[k] === x; });
        b.onclick = function () { picked[k] = x; touched = true; if (!chosen() || !chosen().a) settle(k); draw(); };
        box2.appendChild(b);
      });
      t.appendChild(sl); t.appendChild(box2);
    });
  }
  function frameOf(it, v) {         // ghi kèm khung để khách thấy đúng món mình chọn
    var out = '';
    it.n.forEach(function (n, k) { if (k !== it.z && /frame/i.test(n + ' ' + v.o[k])) out = nice(v.o[k]); });
    return out && !/frame/i.test(out) ? out + ' Frame' : out;
  }
  function tag(it, v) { var f = frameOf(it, v); return v.s + (f ? ', ' + f : ''); }
  function draw() {
    if (!items) return;
    if (!touched) defaults();
    var it = items[cur], x = maths(), v = chosen(), m = mainV(), ps = m ? tag(items[0], m) : pageSize();
    var first = cartLine ? I.inCart : I.this;
    drawTiles(); drawOpts();
    P('v1').src = cartLine ? cartLine.img : pageImg(); P('v1s').textContent = ps;
    P('v2').src = v && m && v.id === m.id && !cartLine ? pageImg() : ((v && v.m) || it.c);
    P('v2n').textContent = cur ? it.t : I.same; P('v2s').textContent = v ? tag(it, v) : '';
    P('nm').textContent = cur ? it.t : I.same;
    addBtn.disabled = !x;
    var pmNow = premFor();
    buildPrem();
    var row = P('premrow'), firstPm = cartLine || !window.ccAddonFor ? null : window.ccAddonFor(ps);
    row.hidden = !pmNow || !row.firstChild;
    if (!row.hidden) {              // ô giữ giá một bức như ô gốc; tổng tiền và số bức nằm ở dòng Premium trong bảng
      P('premprice').textContent = '+' + money((firstPm || pmNow).price);
      row.querySelector('[data-cc-pair-prem]').checked = premOn;
      row.firstChild.classList.toggle('is-checked', premOn);
    }
    if (x) {
      P('r1s').textContent = (x.firstHigher ? first + ', ' + ps : I.second + ', ' + tag(it, v));
      P('r2s').textContent = (x.firstHigher ? I.second + ', ' + tag(it, v) : first + ', ' + ps);
      P('r1').textContent = money(x.hi); P('r2d').textContent = money(x.lo); P('r2').textContent = money(x.lo - x.d);
      P('addonrow').hidden = !x.extra; P('addon').textContent = money(x.extra);
      P('addons').textContent = cartLine ? I.second : I.premBoth;
      P('r3d').textContent = money(x.total + x.d); P('r3').textContent = money(x.total); P('r4').textContent = fill(I.save, x.d);
      addBtn.textContent = cartLine ? I.barOne : I.barAdd;
    }
    publish(!pick.hidden);
  }

  function load() {
    if (items) return Promise.resolve();
    if (loading) return loading;
    var url = '/products/' + box.getAttribute('data-handle') + '?section_id=cc-pair-data';
    loading = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cc-pair-data]');
      items = JSON.parse(el.textContent).filter(function (x) { return x.v.length; });
    }).catch(function (e) { loading = null; throw e; });
    return loading;
  }
  function setErr(on) { P('err').hidden = !on; P('err').textContent = on ? I.err : ''; }
  function open() {
    box.classList.add('is-open'); pick.hidden = false; document.body.classList.add('cc-pair-open'); setErr(false);
    var c = mainPrem(); premWas = c ? c.checked : null; premOn = !cartLine && !!premWas;
    load().then(draw).catch(function () { setErr(true); });
  }
  function close() {
    box.classList.remove('is-open'); pick.hidden = true; document.body.classList.remove('cc-pair-open');
    if (premWas !== null) setMainPrem(premWas);      // thoát ra thì ô gốc về đúng như trước khi mở
    cartLine = null; touched = false; premOn = false; premWas = null; publish(false); boxState();
  }

  function lines(v) {               // bức 2, kèm dòng Premium nếu khách tick
    var pm = premOn ? premFor() : null;
    if (!pm) return [{ id: v.id, quantity: 1 }];
    var link = 'p2' + Date.now().toString(36), props = { _cc_link: link };
    props[pm.material ? 'Material' : 'Upgrade'] = pm.material || 'Yes';
    return [
      { id: pm.id, quantity: 1, properties: { For: items[cur].t + ' (' + v.s.replace(/"/g, '″') + ')', _cc_link: link } },
      { id: v.id, quantity: 1, properties: props }
    ];
  }
  function addBoth() {
    var v = chosen(), main = null;
    if (cartLine && v) {            // bức 1 đã trong giỏ: chỉ thêm bức 2, sang giỏ để mã Pair tự gắn
      addBtn.disabled = true; setErr(false); publish(true, true);
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines(v) })
      }).then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/cart'; })
        .catch(function () { setErr(true); publish(true, false); addBtn.disabled = false; });
      return;
    }
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) { main = main || f.querySelector('[name="add"]'); });
    if (!v || !main || main.disabled) { setErr(true); return; }
    addBtn.disabled = true; setErr(false); publish(true, true);
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines(v) })
    }).then(function (r) { if (!r.ok) throw new Error('add'); main.click(); close(); })
      .catch(function () { setErr(true); publish(true, false); })
      .then(function () { addBtn.disabled = false; });
  }

  // ảnh của đúng lựa chọn khách đang chọn (khung, hướng…), tải khi mở tấm; mỗi variant chỉ tải một lần
  var pics = {}, shown = [];
  function gallery(it, v) {
    if (!pics[v.id]) pics[v.id] = fetch('/products/' + it.h + '?variant=' + v.id + '&section_id=cc-pair-gallery', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (h) { var m = h.match(/<script[^>]*data-cc-pair-gallery[^>]*>([\s\S]*?)<\/script>/); return m ? JSON.parse(m[1]) : []; })
      .catch(function () { delete pics[v.id]; return []; });
    return pics[v.id];
  }
  function small(u) { return String(u).replace(/width=\d+/, 'width=160'); }
  function thumbs(list) {
    var th = S('thumbs'); th.textContent = ''; shown = list;
    list.forEach(function (u, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', I.photo + ' ' + (i + 1));
      var im = document.createElement('img'); im.src = small(u); im.alt = ''; im.loading = 'lazy'; im.width = 80; im.height = 80; b.appendChild(im);
      b.onclick = function () { shot(i); }; th.appendChild(b);
    });
    th.hidden = list.length < 2;
  }
  var at = 0;
  function shot(i) {
    var it = items[cur], im = S('img'), th = S('thumbs').children;
    at = i; im.src = shown[i] || it.c; im.alt = it.t + ', ' + I.photo + ' ' + (i + 1);
    [].forEach.call(th, function (e, k) { e.setAttribute('aria-pressed', k === i); });
    if (th[i] && th[i].scrollIntoView) th[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  // vuốt ngang trên ảnh lớn để qua ảnh trước/sau; vuốt dọc vẫn cuộn tấm như thường
  (function () {
    var im = S('img'), x0 = null, y0 = 0;
    im.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    im.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5 || shown.length < 2) return;
      shot((at + (dx < 0 ? 1 : shown.length - 1)) % shown.length);
    }, { passive: true });
  })();
  var inHistory = false;
  function details(on, fromBack) {
    sheet.hidden = !on; scrim.hidden = !on; document.documentElement.classList.toggle('cc-pair-lock', on);
    if (!on) {
      if (inHistory && !fromBack) history.back();       // nút Back chỉ đóng tấm này, không rời trang
      inHistory = false;
      if (opener) opener.focus();
      return;
    }
    var it = items[cur], v = chosen(), x = maths(), th = S('thumbs');
    if (!v || !x) { details(false); return; }
    var vm = v.m ? String(v.m).replace(/width=\d+/, 'width=640') : it.c;
    thumbs([vm]);                                          // hiện ngay ảnh của variant, bộ ảnh đủ tới sau
    gallery(it, v).then(function (list) { if (sheet.hidden || items[cur] !== it || chosen() !== v || !list.length) return; thumbs(list); shot(0); });
    S('name').textContent = it.t; S('desc').textContent = it.d; S('desc').hidden = it.d.length < 20; S('size').textContent = tag(it, v); S('what').hidden = !!frameOf(it, v);
    var half = x.b <= x.a;
    S('was').hidden = !half; S('was').textContent = half ? money(x.b) : '';
    S('now').textContent = money(half ? x.b - x.d : x.b);
    S('offer').textContent = half ? I.halfHere : fill(I.halfOther, x.a - x.d);
    shot(0); sheet.scrollTop = 0; sheet.focus();
    history.pushState({ ccPairSheet: 1 }, ''); inHistory = true;
  }

  box.addEventListener('change', function (e) {
    if (e.target.matches('[data-cc-pair-prem]')) { premOn = e.target.checked; if (!cartLine) setMainPrem(premOn); draw(); }
  });
  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-pair-open]')) open();
    else if (e.target.closest('[data-cc-pair-close]')) {
      close();
      // đóng bằng nút dưới đáy: box co lại nên đưa khách về đúng chỗ nút "Choose my 2nd painting"
      if (e.target.closest('[data-bottom]')) box.querySelector('[data-cc-pair-open]').scrollIntoView({ block: 'center' });
    }
    else if (e.target.closest('[data-cc-pair-add]')) addBoth();
    else if (e.target.closest('[data-cc-pair-more]')) { showAll = true; draw(); }
    else if (e.target.closest('[data-cc-pair-details]') && items) { opener = e.target.closest('button'); details(true); }
  });
  sheet.addEventListener('click', function (e) { if (e.target.closest('[data-cc-sheet-close]')) details(false); });
  scrim.addEventListener('click', function () { details(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) details(false); });
  window.addEventListener('cc:price', function () { if (items && !pick.hidden) draw(); });
  document.addEventListener('variant:change', function () { if (items && !pick.hidden) setTimeout(draw, 50); });

  window.addEventListener('popstate', function () { if (!sheet.hidden) details(false, true); });

  function paintings() {
    var el = document.querySelector('[data-cc-offer-state]');
    return el ? parseInt(el.getAttribute('data-paintings') || '0', 10) : 0;
  }
  function boxState() {             // giỏ đã có tranh thì box nói đúng tình trạng giỏ, không mời mua thêm 2 bức
    if (!pick.hidden) return;
    var n = paintings(), st = P('state');
    if (n >= 2) { box.setAttribute('data-state', 'on'); st.textContent = I.on; st.hidden = false; }
    else if (n === 1) { box.setAttribute('data-state', 'one'); st.innerHTML = I.one; st.hidden = false; }
    else { box.removeAttribute('data-state'); st.hidden = true; }
  }
  function fromLink() {
    if (location.hash !== '#cc-pair' || paintings() >= 2) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var line = c.items.filter(function (i) { return i.handle === box.getAttribute('data-handle'); })[0];
      if (!line && paintings() === 1) return;             // tranh trong giỏ là tranh khác: box đã mời thêm tranh này
      cartLine = line ? { id: line.variant_id, price: line.original_price, s: String(line.variant_options[line.variant_options.length - 1] || '').replace(/\s*x\s*/i, 'x'), img: line.image } : null;
      box.removeAttribute('data-state'); P('state').hidden = true;
      open(); box.scrollIntoView({ block: 'start' });
    });
  }
  // lời mời trong giỏ trỏ về đúng tranh đang xem thì trang không tải lại: đóng giỏ rồi mở phần chọn
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#cc-pair"]');
    if (!link || link.pathname !== location.pathname) return;
    e.preventDefault();
    var x = document.querySelector('#Cart-Drawer side-panel-close, side-panel-close');
    if (x) x.click();
    history.replaceState(null, '', '#cc-pair'); fromLink();
  });
  var drawer = document.getElementById('Cart-Drawer');
  if (drawer) new MutationObserver(function () { clearTimeout(boxTimer); boxTimer = setTimeout(boxState, 250); }).observe(drawer, { childList: true, subtree: true });
  boxState();
  fromLink();
})();
